import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { useOpenTemplatePicker } from "./useOpenTemplatePicker";
import AccountPicker from "../account-picker/AccountPicker";
export var TemplateOpenerContext = /*#__PURE__*/ React.createContext({
    setTemplateId: function() {
    // do nothing
    }
});
export var TemplateOpenerProvider = function(props) {
    var children = props.children;
    var ref = useState(null), templateId = ref[0], setTemplateId = ref[1];
    return /*#__PURE__*/ _jsxs(TemplateOpenerContext.Provider, {
        value: {
            setTemplateId: setTemplateId
        },
        children: [
            children,
            /*#__PURE__*/ _jsx(TemplateOpener, {
                templateId: templateId,
                setTemplateId: setTemplateId
            })
        ]
    });
};
export var useTemplateOpener = function() {
    return React.useContext(TemplateOpenerContext);
};
var TemplateOpener = function(param) {
    var templateId = param.templateId, setTemplateId = param.setTemplateId;
    var ref = _sliced_to_array(useOpenTemplatePicker(templateId, setTemplateId), 5), isAccountPickerVisible = ref[0], onAccountPickerLoaded = ref[1], onAccountPickerSubmit = ref[2], onAccountPickerCancel = ref[3], onAccountPickerError = ref[4];
    return templateId ? /*#__PURE__*/ _jsx(AccountPicker, {
        isVisible: isAccountPickerVisible,
        onLoaded: onAccountPickerLoaded,
        onSubmit: onAccountPickerSubmit,
        onCancel: onAccountPickerCancel,
        onError: onAccountPickerError
    }) : null;
};
export default TemplateOpener;
